import React from 'react';
import { Card } from '../ui/card';

const ResponsibleDisclosure = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-4">
      <Card className="p-8 bg-black/40 border-white/10">
        <h1 className="heading-1 mb-8 text-white">Responsible Disclosure Policy</h1>
        <div className="space-y-6 text-gray-300 body-medium">
          
          <section>
            <h2 className="heading-2 mb-4 text-white">Security at Godquantum Systems</h2>
            <p>
              At Godquantum Systems, we take security seriously. We appreciate the efforts of security 
              researchers and ethical hackers who help us maintain the security of our systems and protect 
              our users' data.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Scope</h2>
            <p>This policy applies to vulnerabilities found in:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Godquantum.tech website and subdomains</li>
              <li>Godquantum Systems products and services</li>
              <li>Mobile applications developed by Godquantum Systems</li>
              <li>APIs and web services operated by Godquantum Systems</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Reporting Guidelines</h2>
            <h3 className="heading-3 mb-2 text-emerald-300">To report a security vulnerability:</h3>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Send a detailed report to <strong>security@godquantum.tech</strong></li>
              <li>Include proof of concept or steps to reproduce</li>
              <li>Provide technical details and potential impact</li>
              <li>Do not disclose the vulnerability publicly until resolution</li>
              <li>Allow reasonable time for investigation and remediation</li>
            </ol>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">What We Expect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Good faith research and reporting</li>
              <li>No unauthorized access to user data</li>
              <li>No disruption of services or systems</li>
              <li>No social engineering or phishing attacks</li>
              <li>Compliance with applicable laws and regulations</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Our Commitment</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acknowledge receipt within 48 hours</li>
              <li>Provide regular updates on investigation progress</li>
              <li>Credit researchers in public disclosures (if desired)</li>
              <li>Work towards timely resolution of valid vulnerabilities</li>
              <li>Not pursue legal action for good faith security research</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Out of Scope</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Third-party services and applications</li>
              <li>Social engineering attacks</li>
              <li>Physical security issues</li>
              <li>Denial of service attacks</li>
              <li>Issues requiring excessive user interaction</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Legal Protection</h2>
            <p>
              Godquantum Systems will not initiate legal action against researchers who:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Follow this responsible disclosure policy</li>
              <li>Report vulnerabilities in good faith</li>
              <li>Avoid privacy violations and destructive behavior</li>
              <li>Comply with applicable laws and regulations</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">Contact Information</h2>
            <div className="p-4 bg-white/5 rounded-lg border border-emerald-500/20">
              <p><strong>Security Team:</strong> security@godquantum.tech</p>
              <p><strong>General Contact:</strong> contact@godquantum.tech</p>
              <p><strong>Company:</strong> Godquantum Systems Tech Research Labs India Pvt Ltd</p>
              <p className="text-sm text-gray-400 mt-2">
                Bengaluru, Karnataka, India<br/>
                Jurisdiction: New Delhi, India
              </p>
            </div>
          </section>

        </div>
      </Card>
    </div>
  );
};

export default ResponsibleDisclosure;